const EXPIRE_MILI = 60 * 60 * 1000;//一小时无操作，登录超时
import { FGLOBAL } from '../constants/frontGlobal'
/**查询登录状态。若登录成功，更新超时开始时间 */
export function isLogin() {
    let cur = sessionStorage.getItem("cur");
    let login = sessionStorage.getItem("login");
    let interval = Date.now() - cur;

    if (interval > EXPIRE_MILI) {
        // console.log("expired 超出登陆时间");
        sessionStorage.removeItem("login");
        FGLOBAL.clear();
        return false;
    } else if (!login) {
        console.log("未登录");
        return false
    } else {
        if (!FGLOBAL.get('login')) {
            console.log('FG未登录');
            // return false;
        }
        sessionStorage.setItem("cur", Date.now());
        FGLOBAL.set("cur", Date.now());
        return true;
    }
}

/**登录成功，暂存信息至LocalStore */
export function memoLogin(userData) {

    // console.log('userData:', userData);

    let { uid, roleName, token, uname, area, role_id, bill_spot,en_role_name } = userData;

    FGLOBAL.set("login", true);
    FGLOBAL.set("token", token);
    FGLOBAL.set("uid", uid);
    FGLOBAL.set("uname", uname);
    FGLOBAL.set("area", area);
    FGLOBAL.set("roleName", roleName);
    FGLOBAL.set("en_role_name", en_role_name);
    FGLOBAL.set("cur", Date.now());
    FGLOBAL.set("roleId", role_id);
    FGLOBAL.set("billSpot", bill_spot);

    sessionStorage.setItem("login", true);
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("uid", uid);
    sessionStorage.setItem("uname", uname);
    sessionStorage.setItem("area", area);
    sessionStorage.setItem("roleName", roleName);
    sessionStorage.setItem("en_role_name", en_role_name);
    sessionStorage.setItem("cur", Date.now());
    sessionStorage.setItem("roleId", role_id);
    sessionStorage.setItem("billSpot", bill_spot);
}